import { Box, BoxProps, Text } from '@bitrise/bitkit';

type FormBlockProps = BoxProps & {
  isLastItem?: boolean;
  title?: string;
};

const FormBlock = (props: FormBlockProps) => {
  const { children, isLastItem, title, ...rest } = props;
  const boxProps: BoxProps = {
    display: 'flex',
    flexDirection: 'column',
    gap: '24',
    ...rest,
  };
  if (!isLastItem) {
    boxProps.paddingBlockEnd = '24';
    boxProps.borderBlockEnd = '1px solid';
    boxProps.borderBlockEndColor = 'neutral.90';
    boxProps.marginBlockEnd = '24';
  }
  return (
    <Box {...boxProps}>
      {!!title && (
        <Text as="h2" size="4" fontWeight="bold">
          {title}
        </Text>
      )}
      {children}
      {isLastItem}
    </Box>
  );
};

export default FormBlock;
